import { render, staticRenderFns } from "./ProcedureGerer.vue?vue&type=template&id=61d9ef1f&scoped=true"
import script from "./ProcedureGerer.vue?vue&type=script&lang=js"
export * from "./ProcedureGerer.vue?vue&type=script&lang=js"
import style0 from "./ProcedureGerer.vue?vue&type=style&index=0&id=61d9ef1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d9ef1f",
  null
  
)

export default component.exports